var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 112,
    viewBox: "0 0 180 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6154 10.5H28.8461C25.0226 10.5 21.9231 13.634 21.9231 17.5V45.5C21.9231 49.366 25.0226 52.5 28.8461 52.5H79.6154C83.4389 52.5 86.5385 49.366 86.5385 45.5V17.5C86.5385 13.634 83.4389 10.5 79.6154 10.5Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6154 11.6665H28.8462C25.6599 11.6665 23.0769 14.2782 23.0769 17.4998V45.4998C23.0769 48.7215 25.6599 51.3332 28.8462 51.3332H79.6154C82.8017 51.3332 85.3846 48.7215 85.3846 45.4998V17.4998C85.3846 14.2782 82.8017 11.6665 79.6154 11.6665Z",
    stroke: "#D1D5DB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 17.5H33.4615C30.9125 17.5 28.8462 19.5893 28.8462 22.1667V40.8333C28.8462 43.4107 30.9125 45.5 33.4615 45.5H75C77.549 45.5 79.6154 43.4107 79.6154 40.8333V22.1667C79.6154 19.5893 77.549 17.5 75 17.5Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3404 31.7334L52.3731 40.8334H32.3077L42.3404 31.7334Z",
    fill: "#D1D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1766 26.8335L76.1539 40.8335H44.1981L60.1766 26.8335Z",
    fill: "#D1D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.154 10.5H100.385C96.5611 10.5 93.4615 13.634 93.4615 17.5V45.5C93.4615 49.366 96.5611 52.5 100.385 52.5H151.154C154.977 52.5 158.077 49.366 158.077 45.5V17.5C158.077 13.634 154.977 10.5 151.154 10.5Z",
    fill: "#1F2937"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.154 11.6665H100.385C97.1984 11.6665 94.6154 14.2782 94.6154 17.4998V45.4998C94.6154 48.7215 97.1984 51.3332 100.385 51.3332H151.154C154.34 51.3332 156.923 48.7215 156.923 45.4998V17.4998C156.923 14.2782 154.34 11.6665 151.154 11.6665Z",
    stroke: "#111827",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.538 17.5H105C102.451 17.5 100.385 19.5893 100.385 22.1667V40.8333C100.385 43.4107 102.451 45.5 105 45.5H146.538C149.087 45.5 151.154 43.4107 151.154 40.8333V22.1667C151.154 19.5893 149.087 17.5 146.538 17.5Z",
    fill: "#1F2937"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.879 31.7334L123.912 40.8334H103.846L113.879 31.7334Z",
    fill: "#D1D5DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.715 26.8335L147.692 40.8335H115.737L131.715 26.8335Z",
    fill: "#D1D5DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6154 59.5H28.8461C25.0226 59.5 21.9231 62.634 21.9231 66.5V94.5C21.9231 98.366 25.0226 101.5 28.8461 101.5H79.6154C83.4389 101.5 86.5385 98.366 86.5385 94.5V66.5C86.5385 62.634 83.4389 59.5 79.6154 59.5Z",
    fill: "#111827"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6154 60.667H28.8462C25.6599 60.667 23.0769 63.2787 23.0769 66.5003V94.5003C23.0769 97.722 25.6599 100.334 28.8462 100.334H79.6154C82.8017 100.334 85.3846 97.722 85.3846 94.5003V66.5003C85.3846 63.2787 82.8017 60.667 79.6154 60.667Z",
    fill: "#1F2937",
    stroke: "#111827",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66.5H33.4615C30.9125 66.5 28.8462 68.5893 28.8462 71.1667V89.8333C28.8462 92.4107 30.9125 94.5 33.4615 94.5H75C77.549 94.5 79.6154 92.4107 79.6154 89.8333V71.1667C79.6154 68.5893 77.549 66.5 75 66.5Z",
    fill: "#1F2937"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3404 80.7334L52.3731 89.8334H32.3077L42.3404 80.7334Z",
    fill: "#D1D5DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1766 75.833L76.1539 89.833H44.1981L60.1766 75.833Z",
    fill: "#D1D5DB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.154 59.5H100.385C96.5611 59.5 93.4615 62.634 93.4615 66.5V94.5C93.4615 98.366 96.5611 101.5 100.385 101.5H151.154C154.977 101.5 158.077 98.366 158.077 94.5V66.5C158.077 62.634 154.977 59.5 151.154 59.5Z",
    fill: "#111827"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.154 60.667H100.385C97.1984 60.667 94.6154 63.2787 94.6154 66.5003V94.5003C94.6154 97.722 97.1984 100.334 100.385 100.334H151.154C154.34 100.334 156.923 97.722 156.923 94.5003V66.5003C156.923 63.2787 154.34 60.667 151.154 60.667Z",
    fill: "#1F2937",
    stroke: "#111827",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.538 66.5H105C102.451 66.5 100.385 68.5893 100.385 71.1667V89.8333C100.385 92.4107 102.451 94.5 105 94.5H146.538C149.087 94.5 151.154 92.4107 151.154 89.8333V71.1667C151.154 68.5893 149.087 66.5 146.538 66.5Z",
    fill: "#1F2937"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.879 80.7334L123.912 89.8334H103.846L113.879 80.7334Z",
    fill: "#D1D5DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.715 75.833L147.692 89.833H115.737L131.715 75.833Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.e3a59bbc4c75e8bd53bd27ad27ba3b34.svg";
export { ForwardRef as ReactComponent };